const BREADCRUMBS_PANEL_CLASSES_PREFIX = "BreadcrumbsPanel";

export const BREADCRUMBS_PANEL_CLASSES = {
  root: `${BREADCRUMBS_PANEL_CLASSES_PREFIX}-root`,
  link: `${BREADCRUMBS_PANEL_CLASSES_PREFIX}-link`,
};
